import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Button, Col, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import EInput, { EButton } from 'src/Components/EInput';
import { MessageStore } from 'src/Stores/Messages/Messages';
import { UserStore } from 'src/Stores/User/UserStore';
import DeepCopy from 'src/UtilityFunctions/DeepCopy';
import { ISolidsControlEquip } from '../../../../Interfaces/AdminInterface';
import DataService from '../../../../Services/Data';
import DataTable from '../../../DataTable';

interface IList {
    headers: any[];
    rows: any[];
}

@inject('stores')
@observer
class AdminSolidsControlEquips extends React.Component {
    public props: any;
    public adminStore: any;
    public solidsControlEquipsDisposer: any; 
    public solidsControlEquips: ISolidsControlEquip[] = [];
    public solidsControlEquipList: IList;
    public dataService: any = new DataService();
    private UserStore: UserStore;
    private MessageStore: MessageStore;

    private tableHeaders: any[] = [
        { content: 'Name', 'class': 'align-left' },
    ];
 
    public state = {
        rowIndex: 0,
        solidsControlEquip: new ISolidsControlEquip(),
        solidsControlEquips: this.solidsControlEquips,
        solidsModalOpen: false,
    };

    constructor(props: any) {
        super(props);
        this.UserStore = props.stores.UserStore;
        this.adminStore = props.stores.AdminStore;
        this.MessageStore = props.stores.MessageStore;
    }

    public componentDidMount() {

        this.createDisposers();

        this.adminStore.getSolidsControlEquips();
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    public toggleSolidsModal = () => {
        this.setState({
            rowIndex: 0,
            solidsControlEquip: new ISolidsControlEquip(),
            solidsModalOpen: !this.state.solidsModalOpen,
        });
    }

    public addAnother = () => {
        this.handleSaveSolidsControlEquip();
        this.setState({
            solidsControlEquip: new ISolidsControlEquip(),
        });
    }

    public handleSave = () => {
        this.handleSaveSolidsControlEquip();
        this.setState({
            solidsControlEquip: new ISolidsControlEquip(),
            solidsModalOpen: false,
        });
    }

    public handleSaveSolidsControlEquip = () => {
        this.adminStore.saveSolidsControlEquip(this.state.solidsControlEquip)
            .then(
                (data: any) => {
                    if (data) {
                        this.MessageStore.addMessage(
                            'Changes have been saved',
                            'success'
                        );
                        this.adminStore.getSolidsControlEquips();
                    }
                },
                (error: any) => {
                    this.MessageStore.addMessage(
                        error.toString(),
                        'danger'
                    );
                }
            );
    }

    public removeSolidsControlEquipment = (index :number) => {
        const solidsControlEquip = this.state.solidsControlEquips[index];
        this.adminStore.deleteSolidsControlEquip(solidsControlEquip)
            .then(
                (data: any) => {
                    if (data) {
                        this.MessageStore.addMessage(
                            'Solids Control Equipment Successfully Deleted',
                            'success'
                        );
                        this.adminStore.getSolidsControlEquips();
                    }
                }
            );
    }

    public archiveSolidsControlEquipment = (index :number) => {
        const solidsControlEquip = this.state.solidsControlEquips[index];
        this.adminStore.archiveSolidsControlEquip(solidsControlEquip)
            .then(
                (data: any) => {
                    if (data) {
                        this.MessageStore.addMessage(
                            'Solids Control Equipment Successfully Archived',
                            'success'
                        );
                        this.adminStore.getSolidsControlEquips();
                    }
                }
            );
    }

    public onEdit = (index: number) => {
        this.setState({
            rowIndex: index,
            solidsControlEquip: DeepCopy(this.state.solidsControlEquips[index]),
            solidsModalOpen: true,
        });
    }

    public createDisposers() {
        this.solidsControlEquipsDisposer = intercept(this.adminStore, 'solidsControlEquips', (change: any) => {
            let data = change.newValue;
            data = this.dataService.sort(data, { name: 'asc' });
            this.setState({
                solidsControlEquips: data
            });
            return change;
        });
    }

    public handleChange = (event:any) => {
        const solidsControlEquip = this.state.solidsControlEquip;
        solidsControlEquip.deviceName = event.target.value;
        this.setState({
            solidsControlEquip
        });
    }

    public clearDisposers() {
        this.solidsControlEquipsDisposer();
    }

    public formatDataTable() {
        const rows = this.state.solidsControlEquips.map((solidsControlEquip: ISolidsControlEquip, index: number) => {
            return [
                {
                    content: solidsControlEquip.deviceName                    
                },
            ];
        });

        return {      
            headers: this.tableHeaders,
            rows
        };
    }

    public render() {
        return(
            <div>
                <Row className="header">
                    <Col md="6">
                        <h1 className="float-left">Solids Equipment</h1>
                    </Col>
                    {
                        this.UserStore.hasPermission('Permissions.Admin.SolidEquip.Create')
                    }
                </Row>
                <Row>
                    <Col xs="12">
                        <DataTable
                            list={this.formatDataTable()}
                            onNew={this.UserStore.hasPermission('Permissions.Admin.SolidEquip.Create') ? {
                                callback: this.toggleSolidsModal,
                                text: 'Add New Solids Equip'
                            } : undefined}
                            onEdit={this.UserStore.hasPermission('Permissions.Admin.SolidEquip.Update') ? this.onEdit : undefined}
                            onArchive={this.UserStore.hasPermission('Permissions.Admin.SolidEquip.Delete') ? this.archiveSolidsControlEquipment : undefined}
                            onDelete={this.UserStore.hasPermission('Permissions.Admin.SolidEquip.Delete') ? this.removeSolidsControlEquipment: undefined}
                        />
                    </Col>
                </Row>
                <Modal isOpen={this.state.solidsModalOpen} toggle={this.toggleSolidsModal} backdrop="static">
                    <ModalHeader toggle={this.toggleSolidsModal}>
                        Add/Edit Solids Equipment
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md="6">
                                <FormGroup className="required">
                                    <Label>Device Name</Label>
                                    <EInput
                                        type="text"
                                        name="deviceName"
                                        required={true}
                                        value={this.state.solidsControlEquip.deviceName}
                                        onChange={this.handleChange}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.toggleSolidsModal}>Cancel</Button>
                        <EButton color="primary" onClick={this.handleSave}>Save Solids Control Equipment</EButton>
                        <EButton color="primary" onClick={this.addAnother}>Add Another</EButton>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

export default AdminSolidsControlEquips;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/SolidsControlEquips/AdminSolidsControlEquips.tsx